import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../lib/auth-context'

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return <div>Loading...</div>
  }

  if (!user) {
    const searchParams = new URLSearchParams(location.search)
    const isFromInApp = searchParams.get('from') === 'inapp'
    const redirectPath = isFromInApp ? '/auth/sign-in?from=inapp' : '/auth/sign-in'
    return <Navigate to={redirectPath} />
  }

  return <>{children}</>
}
